var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "c-content" },
    [
      _c("div", { staticClass: "title" }, [
        _c("div", { staticClass: "span" }, [_vm._v("默认运费")]),
        _c(
          "div",
          { staticClass: "span" },
          [
            _c("el-input", {
              attrs: {
                disabled: !_vm.isEdit,
                oninput: "value=value.replace(/^0|[^0-9]/g, '')",
              },
              model: {
                value: _vm.baseNumber1,
                callback: function ($$v) {
                  _vm.baseNumber1 = $$v
                },
                expression: "baseNumber1",
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "span" }, [_vm._v("件")]),
        _c(
          "div",
          { staticClass: "span" },
          [
            _c("el-input", {
              attrs: {
                disabled: !_vm.isEdit,
                oninput:
                  "value=value.replace(/^\\D*([0-9]\\d*\\.?\\d{0,2})?.*$/,'$1')",
              },
              model: {
                value: _vm.freight1,
                callback: function ($$v) {
                  _vm.freight1 = $$v
                },
                expression: "freight1",
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "span" }, [_vm._v("元")]),
        _c("div", { staticClass: "span" }, [_vm._v("每增加")]),
        _c(
          "div",
          { staticClass: "span" },
          [
            _c("el-input", {
              attrs: {
                disabled: !_vm.isEdit,
                oninput: "value=value.replace(/^0|[^0-9]/g, '')",
              },
              model: {
                value: _vm.addNum1,
                callback: function ($$v) {
                  _vm.addNum1 = $$v
                },
                expression: "addNum1",
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "span" }, [_vm._v("件")]),
        _c("div", { staticClass: "span" }, [_vm._v("增加运费")]),
        _c(
          "div",
          { staticClass: "span" },
          [
            _c("el-input", {
              attrs: {
                disabled: !_vm.isEdit,
                oninput:
                  "value=value.replace(/^\\D*([0-9]\\d*\\.?\\d{0,2})?.*$/,'$1')",
              },
              model: {
                value: _vm.addPrice1,
                callback: function ($$v) {
                  _vm.addPrice1 = $$v
                },
                expression: "addPrice1",
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "span" }, [_vm._v("元")]),
      ]),
      _c(
        "div",
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "date", label: "运送到", width: "300px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.address))]),
                        _vm.isEdit
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  "margin-left": "10px",
                                  color: "red",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.add(
                                      "edit",
                                      scope.row,
                                      scope.$index
                                    )
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "firstNum", label: "首件数（件）" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: { size: "small", disabled: !_vm.isEdit },
                          model: {
                            value: scope.row.firstNum,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "firstNum", $$v)
                            },
                            expression: "scope.row.firstNum",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "freight", label: "收费（元）" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: { size: "small", disabled: !_vm.isEdit },
                          model: {
                            value: scope.row.freight,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "freight", $$v)
                            },
                            expression: "scope.row.freight",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "addNum", label: "续件数（件）" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: { size: "small", disabled: !_vm.isEdit },
                          model: {
                            value: scope.row.addNum,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "addNum", $$v)
                            },
                            expression: "scope.row.addNum",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "addPrice", label: "续费（元）" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: { size: "small", disabled: !_vm.isEdit },
                          model: {
                            value: scope.row.addPrice,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "addPrice", $$v)
                            },
                            expression: "scope.row.addPrice",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm.isEdit
                ? _c("el-table-column", {
                    attrs: { prop: "num", label: "操作" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                {
                                  staticStyle: { color: "red" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteArea(scope.$index)
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2136252081
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", [
        _vm.isEdit
          ? _c(
              "div",
              { staticStyle: { "margin-top": "20px", "text-align": "center" } },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { color: "#137dff" },
                    on: {
                      click: function ($event) {
                        return _vm.add("add")
                      },
                    },
                  },
                  [_vm._v("添加指定城市价格")]
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择地区",
            visible: _vm.isShow,
            width: "40%",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShow = $event
            },
          },
        },
        [
          [
            _vm._l(_vm.cityData, function (item, index) {
              return _c(
                "div",
                { key: index, staticStyle: { display: "flex" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-top": "2px",
                        "margin-right": "4px",
                      },
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.handleCheckAllChange(
                                index,
                                item.checked
                              )
                            },
                          },
                          model: {
                            value: item.checked,
                            callback: function ($$v) {
                              _vm.$set(item, "checked", $$v)
                            },
                            expression: "item.checked",
                          },
                        },
                        [_vm._v(_vm._s(item.label))]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c("el-tree", {
                        ref: "tree",
                        refInFor: true,
                        attrs: {
                          data: item.children,
                          "show-checkbox": "",
                          "node-key": "id",
                          "default-expand-all": false,
                          "expand-on-click-node": true,
                          "default-checked-keys": _vm.checkId,
                          props: _vm.defaultPorps,
                        },
                        on: {
                          "check-change": function ($event) {
                            return _vm.checkChange(index)
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ node }) {
                                return _c(
                                  "span",
                                  { staticClass: "custom-tree-node" },
                                  [
                                    _c("span", [_vm._v(_vm._s(node.label))]),
                                    _c("i", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: node.level == 1,
                                          expression: "node.level == 1",
                                        },
                                      ],
                                      staticClass: "el-icon-caret-bottom",
                                      staticStyle: {
                                        "font-size": "20px",
                                        "margin-left": "4px",
                                        "margin-top": "2px",
                                      },
                                    }),
                                  ]
                                )
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  ),
                ]
              )
            }),
            _c("div", { staticStyle: { margin: "15px 0" } }),
            _c(
              "div",
              { staticStyle: { "text-align": "center", "margin-top": "20px" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.saveAddress },
                  },
                  [_vm._v("保存")]
                ),
              ],
              1
            ),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }